module.exports = __webpack_public_path__ + "img/MiddleSide_right.471be6eb.jpg";